import { useEffect, useState } from "react";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Call from "./components/Call";
import WhyUs from "./components/WhyUs";
import Services from "./components/Services";
import Proceso from "./components/Proceso";
import Resultados from "./components/Resultados";
import Footer from "./components/Footer";
import Formulario from "./components/Formulario";
import CasosExito from "./components/CasosExito";
import Section1 from "./components/Section1";
import CustomModal from "./components/CustomModal"; 
import Bot from "./components/Bot";
import FAQ from "./components/FAQ";
import IndicadorAds from "./components/IndicadorAds";
import "./styles/App.scss";

function App() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem("promoSeen");
    if (!hasSeenModal) {
      setShowModal(true);
      sessionStorage.setItem("promoSeen", "true");
    }
  }, []);

  const handleClose = () => setShowModal(false);

  return (
    <div>
      <CustomModal show={showModal} onClose={handleClose} />
      <Header />
      <Section1 />
      <IndicadorAds />
      <Hero />
      <WhyUs />
      <Call />
      <Services />
      <Proceso />
      <Resultados />
      <CasosExito />
      <FAQ />
      <Bot />
      <Footer />
    </div>
  );
}

export default App;
